function countdown( elementName, minutes, seconds ){
    var element, endTime, hours, mins, msLeft, time;
    function twoDigits( n ) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if ( msLeft < 1000 ) {
            element.innerHTML = "Time is up!";
        } else {
            time = new Date( msLeft );
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
            setTimeout( updateTimer, time.getUTCMilliseconds() + 500 );
        }
    }

    element = document.getElementById( elementName );
    endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
    updateTimer();
}
 
$('document').ready(function(){
  $("[data-modal]").on('click', function(){
     var modalID = $(this).attr("data-modal");
     $('.custom-modal#'+modalID).addClass('show');
  });
  
  $('.custom-modal__close').on('click', function(){
    $(this).parents('.custom-modal').removeClass('show');
  });
});

jQuery('.order--product').click(function(e){
  e.preventDefault();
  let productID = jQuery('.order--product-ID').val();
  if(productID){
     $.ajax({
          type: 'POST',
          url: window.Shopify.routes.root + 'cart/add.js',
          dataType: 'json',
          data: {'id': productID, 'quantity': 1 },
          success: function (response) {
              console.log('Success:', response);               
              window.location.href = '/checkout?express';
          },
          error: function (xhr, status, error) {
              console.error('Error:', error);
          }
      });
  }
  });
